import React, { useEffect, useRef } from 'react';
import { Animated, View } from 'react-native';
import { Text } from '@/components/Text';

import { styles } from './styles';

interface NewNavigationHighlightProps {
  enabled?: boolean;
  children: React.ReactNode;
  position?: 'right' | 'left';
}

export const NewNavigationHighlight = ({
  enabled = false,
  children,
  position = 'right',
}: NewNavigationHighlightProps) => {
  const scale = useRef(new Animated.Value(1)).current;

  useEffect(() => {
    if (!enabled) {
      return;
    }

    Animated.loop(
      Animated.sequence([
        Animated.timing(scale, {
          toValue: 1.2,
          duration: 1000,
          useNativeDriver: true,
        }),
        Animated.timing(scale, {
          toValue: 1,
          duration: 1000,
          useNativeDriver: true,
        }),
      ]),
      { iterations: 4 },
    ).start();
  }, [enabled]);

  if (!enabled || !enabled) {
    return <>{children}</>;
  }

  return (
    <Animated.View style={{ transform: [{ scale }] }}>
      <View>
        {children}
        <View style={[styles.badge, styles[position]]}>
          <Text style={styles.badgeText}>NEU</Text>
        </View>
      </View>
    </Animated.View>
  );
};
